<template>
  <div class="gi-search gi-search--show">
    <div class="gi-search__inner">
      <div class="gi-search__top">
        <button class="gi-search__close" @click="closeSearch">
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.83 9l5.66 5.66-2.83 2.83L9 11.83l-5.66 5.66-2.83-2.83L6.17 9 .51 3.34 3.34.51 9 6.17 14.66.51l2.83 2.83L11.83 9z"
              fill="#FFFFFF"
              fill-rule="nonzero"
            />
          </svg>
        </button>
      </div>
      <div class="gi-search__search-area">
        <div class="gi-search__heading">{{ translation.title }}</div>
        <div
          class="gi-search__input-area"
          :class="{ 'gi-search__input-area--move-up': ready }"
        >
          <input
            ref="search"
            v-model="searchString"
            class="gi-search__input"
            :placeholder="translation.placeholder + '...'"
            @keyup.esc="closeSearch"
          />

          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 72 72"
            class="gi-search__load-icon"
            v-if="loading"
          >
            <g data-name="Layer 2">
              <path
                d="M36 57.75a21.75 21.75 0 0 1 0-43.5V0a36 36 0 1 0 36 36H57.76A21.75 21.75 0 0 1 36 57.75z"
                fill="#fff"
                data-name="Layer 1"
              />
            </g>
          </svg>

          <svg
            width="23"
            height="26"
            v-if="!loading && results.length === 0"
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="search"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            class="gi-search__icon svg-inline--fa fa-search fa-w-16 fa-3x"
          >
            <path
              fill="currentColor"
              d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
              class=""
            ></path>
          </svg>

          <button
            class="gi-search__clear-icon"
            @click.prevent="clearSearch"
            v-if="!loading && results.length > 0"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.83 9l5.66 5.66-2.83 2.83L9 11.83l-5.66 5.66-2.83-2.83L6.17 9 .51 3.34 3.34.51 9 6.17 14.66.51l2.83 2.83L11.83 9z"
                fill="#FFFFFF"
                fill-rule="nonzero"
              />
            </svg>
          </button>
        </div>
        <div
          class="gi-search__result-count"
          v-if="totalResults || (totalResults === 0 && searchString.length > 0)"
        >
          {{ translation.yoursearch }}
          <span class="bold"
            >"{{ searchString }}" {{ translation.gave }} {{ totalResults }}
            {{ resultsLabel }}</span
          >
        </div>
      </div>
      <div class="gi-search__result-area">
        <ul class="gi-search__results">
          <li
            class="gi-search__item"
            v-for="(item, index) in results"
            :key="index"
            data-aos="fade-up"
            :data-aos-delay="index + 1 + '00'"
          >
            <a :href="item.link" class="gi-search__card">
              <div class="gi-search__name" v-html="item.title"></div>
              <div class="gi-search__type" v-if="item.type == 'news'">
                {{ translation.news }}
              </div>
              <div class="gi-search__type" v-else>
                {{ translation.information }}
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import EventBus from "../eventBus";

export default {
  name: "EgSearch",
  props: {
    homeUrl: {
      type: String,
      default: "/",
    },
    lang: {
      type: String,
      default: "/",
    },
    translation: Object,
  },
  data: () => ({
    searchString: "",
    searchFor: "",
    results: [],
    totalResults: null,
    loading: false,
    ready: false,
    noResults: true,
    showTop: false,
  }),
  computed: {
    resultsLabel() {
      if (this.totalResults === 1) {
        return this.translation.result;
      } else {
        return this.translation.results;
      }
    },
  },
  watch: {
    searchString(string) {
      this.inputChanged(string, this);
    },
  },
  methods: {
    getResults() {
      this.results = [];
      this.totalResults = null;
      if (this.searchFor.length > 2) {
        this.loading = true;
      }
      $.get(
        "/" +
          this.lang +
          "/wp-json/sl/v1/search" +
          "?keyword=" +
          this.searchFor.replace(" ", "%20")
      )
        .then((result) => {
          if (this.searchFor.length > 2) {
            this.results = result;
          } else {
            this.results = [];
            this.totalResults = null;
          }
          this.totalResults = this.results.length;
        })
        .catch((e) => {
          console.log(e);
        })
        .always(() => {
          this.loading = false;
        });
    },
    inputChanged: debounce((string, vm) => {
      vm.searchFor = string;
      vm.getResults();
    }, 500),
    closeSearch() {
      EventBus.$emit("close-search");
    },
    clearSearch() {
      this.results = [];
      this.totalResults = null;
      this.searchFor = "";
      this.searchString = "";
    },
  },
  mounted() {
    this.showTop = true;
    setTimeout(() => {
      this.ready = true;
      this.$refs.search.focus();
    }, 100);
    EventBus.$emit("current-scrollpos", window.scrollY);
  },
};

// Lodash alternative
function debounce(fn, time) {
  let timeoutId;
  return wrapper;
  function wrapper(...args) {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      timeoutId = null;
      fn(...args);
    }, time);
  }
}
</script>

<style lang="scss">
@import "~sass-mq/mq";
@import "~sass-nitty/nitty";
@import "../../../_scss/_vars.scss";
@import "../../../_scss/utils/utils.scss";

.gi-search {
  position: absolute;
  width: 100%;
  top: 0;
  bottom: 0;
  z-index: 100;
  padding-top: rem(20px);
  background-color: $c-primary;
  opacity: 0;
  transition: opacity 300ms $t-nice;

  &__close {
    cursor: pointer;
    background: 0;
    border: none;
    padding: 0;
    margin: 0;
  }

  &__inner {
    @include grid-container;
  }

  &__top {
    width: 100%;
    text-align: right;
    display: inline-flex;
    flex-flow: row nowrap;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: rem(45px);
  }

  &__logo {
    margin-top: rem(5px);
    height: 46px;
    width: auto;
  }

  &__logo-link {
    display: inline-block;
  }

  &--show {
    opacity: 1;
  }

  &__heading {
    text-align: center;
    font-size: rem(50px);
    line-height: rem(55px);
    color: #fff;
    font-weight: 300;
  }

  &__input-area {
    width: 100%;
    margin: 0 auto;
    margin-top: rem(45px);
    position: relative;
    transform: translateY(80px) scale(0.95);
    opacity: 0;
    opacity: 0;
    transition: transform 600ms $t-nice, opacity 200ms $t-nice;

    input {
      font-family: $f-family;
      &::placeholder {
        opacity: 0.5;
      }
    }

    &--move-up {
      transform: translateY(0) scale(1);
      opacity: 1;
    }
  }

  &__input {
    color: #fff;
    font-size: rem(23px);
    line-height: rem(31px);
    width: 100%;
    background-color: transparent;
    border: 0;
    border-bottom: 1px solid #fff;
    border-radius: 0;
    appearance: none;
    -webkit-appearance: none;
    padding-bottom: rem(20px);

    @include placeholder {
      color: #fff !important;
    }
  }

  &__icon {
    position: absolute;
    right: rem(5px);
    bottom: rem(20px);

    path {
      fill: #fff;
    }
  }

  &__clear-icon {
    width: 18px;
    height: 18px;
    position: absolute;
    right: rem(5px);
    bottom: rem(20px);
    animation: fade-in 300ms ease-in forwards;
    background: 0;
    border: none;
    padding: 0;
    margin: 0;
    &:hover {
      cursor: pointer;
    }
  }

  &__load-icon {
    width: 23px;
    height: 23px;
    position: absolute;
    right: rem(5px);
    bottom: rem(20px);
    animation: search-load 0.8s linear infinite;
  }

  &__result-count {
    width: 100%;
    margin: 0 auto;
    color: #fff;
    font-size: rem(13px);
    line-height: rem(18px);
    margin-top: rem(10px);

    .bold {
      font-weight: 900;
    }
  }

  &__results {
    width: 100%;
    margin: 0 auto;
    margin-top: rem(70px);
  }

  &__item {
    margin-bottom: rem(6px);
  }

  &__card {
    background-color: #fff;
    box-shadow: -6px 3px 26px 0 rgba(0, 0, 0, 0.11);
    display: block;
    padding: rem(37px) rem(35px);
    transition: transform 300ms $t-nice;

    &:hover,
    &:focus {
      outline: 0;
      transform: scale(1.01);
    }
  }

  &__name {
    font-size: rem(19px);
    line-height: rem(26px);
    color: $c-font;
    font-weight: 700;
    margin-bottom: rem(8px);
  }

  &__type {
    color: $c-yellow;
    font-weight: 700;
    font-size: rem(13px);
    line-height: rem(18px);
  }
}

@include mq(md) {
  .gi-search {
    &__input-area,
    &__results,
    &__result-count {
      width: grid-width(8);
    }
  }
}

@include mq(lg) {
  .gi-search {
    padding-top: rem(70px);

    &__logo {
      margin-top: 0;
      height: 72px;
      width: auto;
    }

    &__close {
      display: block;
      top: rem(50px);
      right: rem(60px);
    }

    &__input-area,
    &__results,
    &__result-count {
      width: grid-width(6);
    }
  }
}

@include mq(xl) {
  .gi-search {
    padding-top: rem(70px);
  }
}

@keyframes search-load {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes fade-in {
  0% {
    opacity: 0;
    transform: rotate(-180deg);
  }
  100% {
    opacity: 1;
    transform: rotate(0);
  }
}

@include mq(xx) {
  .gi-search__inner {
    @include grid-container($max-width: 1440px);
  }
}

@include mq(xxx) {
  .gi-search__inner {
    @include grid-container($max-width: 1640px);
  }
}

// Results animation
.result-enter-active,
.result-leave-active {
  transition: opacity 300ms $t-nice, transform 500ms $t-nice;
}
.result-enter {
  opacity: 0;
  transform: translateY(30px);
}

.result-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// assets/_js/components/EgSearch/EgSearch.vue